import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { trackPageView, trackPaymentCancelled as gtmTrackPaymentCancelled } from '../utils/gtm';
import * as Analytics from '../utils/analytics';
import './PaymentCancel.css';

function PaymentCancel() {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Track page view and payment cancellation (both GTM and Firebase Analytics)
    trackPageView('/payment/cancel', 'Payment Cancelled - OSIN7');
    
    const selectorType = sessionStorage.getItem('selector_type') || 'email';
    gtmTrackPaymentCancelled(selectorType);
    Analytics.trackPaymentCancelled(selectorType);
    
    // Clean up sessionStorage
    sessionStorage.removeItem('pending_report_id');
    sessionStorage.removeItem('upgrade_report_id');
  }, []);

  return (
    <div className="payment-cancel-page">
      <div className="payment-cancel-container">
        <div className="cancel-content">
          <div className="cancel-icon">
            <i className="bi-x-circle"></i>
          </div>
          <h1>Payment Cancelled</h1>
          <p className="cancel-message">
            Your payment was cancelled. No charges were made to your account.
          </p>
          <p className="cancel-note">
            You can return home to try again or explore other options.
          </p>
          <div className="cancel-actions">
            <button 
              className="retry-button"
              onClick={() => navigate('/')}
            >
              <i className="bi-arrow-left"></i> Return to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentCancel;

